import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import { axiosInstance, baseURL } from "src/api/axios";
import CustomTextField from "../../components/forms/theme-elements/CustomTextField";

// components
import axios from "axios";
import Loader from "react-loaders";
import LogoMobile from "src/assets/images/logos/mobile.png";
import PageContainer from "src/components/container/PageContainer";

const SubmitButton = ({ theme, submit_func }) => (
  <Box sx={{ width: "100%" }}>
    <Stack alignItems={"end"} width={"100%"}>
      <Typography
        component={Link}
        to="https://www.earnpati.com/trouble-login"
        fontWeight="500"
        fontSize="14px"
        sx={{
          textDecoration: "none",
          color: "earnpati.main",
        }}
      >
        Having trouble Signing in ?
      </Typography>
    </Stack>
    <Button
      sx={{ bgcolor: theme.palette.earnpati.success, my: 2 }}
      variant="contained"
      size="large"
      fullWidth
      style={{ ml: "1rem" }}
      onClick={submit_func}
    >
      <Typography sx={{ fontWeight: 700 }}>Send OTP</Typography>
    </Button>
    <ToastContainer />
  </Box>
);
const MobileLogin = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [number, setNumber] = useState();
  const [userState, setUserState] = useState();

  const [error, setError] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      if (localStorage.getItem("token")) {
        axiosInstance
          .get("/users/profile")
          .then((response) => {
            if (response.status >= 400) {
              return;
            }
            if (response.status < 205 && response.data) {
              let { role } = response.data.user;
              if (role === "admin") {
                navigate("/admin/");
              } else {
                navigate("/dashboard");
              }
            }
          })
          .catch((e) => {});
      }
    }, 2000);
  }, []);

  const sendPasswordRequest = async (e) => {
    e.preventDefault();
    let response = await axios
      .post(`${baseURL}/auth/phone_login`, {
        phoneNumber: number,
      })
      .then((res) => res)
      .catch((e) => e);
    if (response.status === 200) {
      let { userExists, passwordExists, token } = response.data;
      setUserState(response.data);
      console.log(response.data);
      // if (token) {
      navigate("/auth/verify", {
        state: { passwordExists, number, userExists, token },
      });
      // }else{

      // }
      // if (role === "admin") {
      //   window.location.href = "/admin";
      // } else {
      //   window.location.href = "/dashboard";
      // }
    } else {
      setError(
        "response" in response ? response.response.data.message : response.data
      );
    }
  };

  return (
    <PageContainer title="Login" description="this is Login page">
      {false ? (
        <Loader type={"ball-scale-multiple"} />
      ) : (
        <Grid
          container
          spacing={0}
          justifyContent="space-between"
          alignItems={"center"}
          sx={{ height: "100vh" }}
        >
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            direction={"column"}
            height={"100vh"}
            px={2}
          >
            <Box
              display="flex"
              justifyContent="space-around"
              sx={{ flexDirection: "column" }}
              height={"100%"}
              width="85%"
              maxWidth={"480px"}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ flexDirection: "column" }}
              >
                <img
                  height="auto"
                  width={200}
                  src={LogoMobile}
                  style={{ marginTop: "5px" }}
                  alt="Logo Earnpati"
                />
                <Typography
                  variant="h5"
                  textAlign="center"
                  color="black"
                  mb={5}
                >
                  Start Your Earning Journey
                </Typography>
              </Box>
              <Stack
                onKeyDown={(e) => {
                  // if (e.key === "Enter" && !open) {
                  //   submit(e);
                  // }
                }}
                sx={{
                  height: "50%",
                  marginBottom: "2rem",
                }}
              >
                <Typography variant="h5" mb="15px">
                  Login/Sign Up
                </Typography>

                <Typography
                  variant="subtitle2"
                  sx={{ width: "100%" }}
                  component="label"
                  mb="5px"
                >
                  Enter your 10 digit mobile number
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ width: "100%" }}
                  component="label"
                  mb="5px"
                >
                  We wil send you an OTP to verify
                </Typography>
                <form style={{ marginTop: "15px" }}>
                  <Box>
                    <CustomTextField
                      id="phonenumber"
                      variant="outlined"
                      fullWidth
                      type={"number"}
                      setState={setNumber}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          sendPasswordRequest(e);
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">+91</InputAdornment>
                        ),
                      }}
                    />
                  </Box>

                  <Typography
                    variant="caption"
                    fontWeight={600}
                    sx={{
                      color: "red",
                      display: error ? "block" : "none",
                    }}
                  >
                    {error}
                  </Typography>

                  <Stack
                    justifyContent="space-between"
                    direction="row"
                    alignItems="center"
                    my={2}
                    mt={5}
                  >
                    <Box></Box>
                    {!mdDown ? (
                      <SubmitButton
                        theme={theme}
                        submit_func={sendPasswordRequest}
                      />
                    ) : null}
                  </Stack>
                </form>
              </Stack>
            </Box>

            <Stack
              direction={"column"}
              justifyContent={"flex-end"}
              sx={{
                minHeight: `${(window.screen.availHeight / 2 / 100) * 32}px`,
                width: "85%",
              }}
            >
              {mdDown ? (
                <SubmitButton theme={theme} submit_func={sendPasswordRequest} />
              ) : null}
            </Stack>
            <ToastContainer />
          </Grid>
        </Grid>
      )}
    </PageContainer>
  );
};

export default MobileLogin;
